export const FEATURE_NAME = '@zerops/zerops/core/notification-base';
export const UNREAD_NOTIFICATION_LIST_KEY = `${FEATURE_NAME}/unread`;
